import React, { useEffect, useState } from 'react';
import { StoreItem } from './StoreItem';
import { Facebook } from 'react-spinners-css';
import { useServices } from '../../hooks/useServices';
import { OfertaError } from '../oferta/OfertaError';


export const StoreUbicacion = ( coordenadas ) => {

    

    const [searchTerm, setSearchTerm] = useState("");
    const [tiendas, setTiendas] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [errorRequest, setErrorRequest] = useState(false);
    const [cargador, setCargador] = useState(true);

    const { getTiendasHaversine } = useServices();


    useEffect(() => {
        const {valor: coords} = coordenadas;
        console.log('coordenadas: ', coords);
        async  function fetchInitialData() {
          const response = await getTiendasHaversine(coords.lat,coords.lng);
          if (response) {
            response.status ? setErrorRequest(true) : setTiendas(response);
            setSearchResults(response);
            setCargador(false);
          }else{
            setErrorRequest(true);
            setCargador(false);
          }
          
          console.log('tiendas: ', response);
        }
        fetchInitialData();
      }, []);


      

    const handleChange = e => {
        setSearchTerm(e.target.value);
      };

      useEffect(() => {
        const newArray = tiendas.filter(item => item.tipo.toLowerCase().includes(searchTerm.toLowerCase()));
        setSearchResults(newArray);
      }, [searchTerm]);
      

     
   
    return (
        <div className="contenedorTiendas">

            { !cargador 
                ? !errorRequest
                    ?
                        <div>
                            <div className="cabezaBusca">
                                <div className="contInputbusca animate__animated animate__slideInLeft">
                                    <input type="text"  className="buscador" placeholder="Filtrar por nombre" value={searchTerm} onChange={handleChange}/>
                                    <div className="icoBusca"></div>
                                </div>
                            </div>
        
                                <div className="scrollTiendas">
                                    {
                                        searchResults.map( (tienda, i) => (
                                            <StoreItem key={ i } {...tienda}/>
                                            )
                                        )
                                    }
                                </div>
                        </div>
                    : <>
                        <div className="logoUnefon animate__animated animate__slideInLeft"></div>
                        <OfertaError/>
                       </> 
                    
                : <div className="spinner"><Facebook color="#594498"/></div>
                
            } 
        </div>
    )
}
